import { useEffect, useState } from "react";
import axios from "../../util/axiosConfig";
import MyFactStats from "../../component/MyFactStats";
import "../../assets/css/container/main/MyStatsPage.css";

type Post = {
	id: number;
	title: string;
	createdAt: string;
};

export default function MyStatsPage() {
	const [posts, setPosts] = useState<Post[]>([]);
	const [selectedPost, setSelectedPost] = useState<number | null>(null);
	const [stats, setStats] = useState<any>(null);

	// ✅ 내 게시글 목록 불러오기
	useEffect(() => {
		axios.get("/api/mystats/posts")
			.then(res => setPosts(res.data))
			.catch(err => {
				if (err.response?.status === 401) {
					alert("로그인이 필요합니다.");
					window.location.href = "/login";
				}
			});
	}, []);

	// ✅ 특정 게시글 통계 불러오기
	const loadStats = (postId: number) => {
		setSelectedPost(postId);
		axios.get(`/api/mystats/${postId}`)
			.then(res => setStats(res.data))
			.catch(err => {
				if (err.response?.status === 401) {
					alert("로그인이 필요합니다.");
					window.location.href = "/login";
				}
			});
	};

	return (
		<div className="MyStatsPage" style={{ display: "flex", gap: "24px" }}>
			{/* 왼쪽: 내가 쓴 글 목록 */}
			<div className="PostList" style={{ width: "30%" }}>
				<h2>내 글 목록</h2>
				<ul>
					{posts.map(p => (
						<li key={p.id}>
							<button onClick={() => loadStats(p.id)}>
								{p.title}
							</button>
						</li>
					))}
				</ul>
			</div>

			{/* 오른쪽: 통계 영역 */}
			<div className="StatsArea" style={{ flex: 1 }}>
				{stats ? (
					<MyFactStats stats={stats} />
				) : (
					<p>왼쪽에서 게시글을 선택하면 통계가 표시됩니다.</p>
				)}
			</div>
		</div>
	);
}
